import Lottie from "lottie-react"
import flowerAnimation from "./Cyber Security.json"

const MainLoader = () => {
  const fullScreenAnimationStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    zIndex: -1, // Behind the page content
    pointerEvents: "none", // Prevent interaction
  }

  return (
    <div style={fullScreenAnimationStyle}>
      <Lottie
        animationData={flowerAnimation}
        loop={true} // Loop for continuous effect
        autoplay={true}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  )
}

export default MainLoader
